export const articles = {
  article1: {
    id: 'coworking',
    title: 'La révolution des espaces de coworking en France',
    subtitle: 'Comment ces nouveaux lieux transforment notre rapport au travail et favorisent la créativité',
    intro: 'Depuis une dizaine d\'années, les espaces de coworking se multiplient dans les grandes villes françaises. Ces lieux hybrides, entre bureau et café, attirent freelances, startups et même grandes entreprises en quête de flexibilité.',
    sections: [
      {
        interTitle: 'Un phénomène en pleine expansion',
        paragraphs: [
          'Paris compte aujourd\'hui plus de 600 espaces de coworking, contre une cinquantaine il y a dix ans. Cette croissance s\'explique par l\'évolution des modes de travail. Le télétravail, accéléré par la pandémie, a poussé de nombreux professionnels à chercher des alternatives au bureau traditionnel et au domicile.',
          'Ces espaces proposent bien plus qu\'un simple poste de travail. Salles de réunion équipées, espaces de détente, événements de networking : tout est pensé pour créer une communauté et stimuler les échanges entre professionnels de secteurs variés.'
        ]
      },
      {
        interTitle: 'Les avantages pour les travailleurs indépendants',
        paragraphs: [
          'Pour les freelances, le coworking représente une solution idéale. Fini l\'isolement du travail à domicile et les distractions domestiques. L\'espace de coworking offre un cadre professionnel sans les contraintes d\'un bail commercial. La flexibilité des formules, du pass journée à l\'abonnement annuel, s\'adapte à tous les budgets et besoins.'
        ]
      },
      {
        interTitle: 'Des défis à relever',
        paragraphs: [
          'Malgré leur succès, ces espaces font face à des défis. Le bruit, la difficulté de concentration dans les open spaces et la standardisation de l\'offre sont régulièrement pointés du doigt. Certains acteurs du secteur cherchent désormais à se différencier en proposant des espaces thématiques ou en misant sur des services premium.'
        ]
      }
    ]
  },
  
  article2: {
    id: 'street-art',
    title: 'Quand le street art entre au musée',
    subtitle: 'Une reconnaissance tardive mais éclatante pour un mouvement artistique longtemps contesté',
    intro: 'Longtemps considéré comme du vandalisme, le street art conquiert aujourd\'hui les institutions culturelles les plus prestigieuses. Une évolution qui interroge la nature même de cet art né dans la rue.',
    sections: [
      {
        interTitle: 'De la rue aux cimaises',
        paragraphs: [
          'Le Musée d\'Art Moderne de Paris consacre cet automne une rétrospective à Banksy, figure emblématique du street art. Cette exposition marque un tournant : l\'art urbain, autrefois marginal, obtient enfin une reconnaissance institutionnelle. Des artistes comme JR, Invader ou Miss.Tic sont désormais exposés aux côtés des grands maîtres de l\'art contemporain.',
          'Cette légitimation pose question. En entrant au musée, le street art perd-il son âme rebelle ? Pour certains puristes, l\'essence même de cet art réside dans son illégalité, son éphémère et son accessibilité gratuite dans l\'espace public.'
        ]
      },
      {
        interTitle: 'Un marché en pleine explosion',
        paragraphs: [
          'Au-delà de la reconnaissance culturelle, le street art connaît un succès commercial fulgurant. Les œuvres de Banksy s\'arrachent à prix d\'or dans les ventes aux enchères, dépassant parfois le million d\'euros. Des galeries spécialisées ouvrent partout en Europe, transformant des artistes underground en stars cotées sur le marché de l\'art.'
        ]
      },
      {
        interTitle: 'L\'avenir d\'un mouvement en mutation',
        paragraphs: [
          'Face à cette institutionnalisation, de jeunes artistes choisissent de rester dans la rue, refusant toute récupération commerciale. Ils perpétuent l\'esprit originel du mouvement : un art libre, accessible à tous, qui transforme la ville en galerie à ciel ouvert. Le débat entre reconnaissance et authenticité continue d\'animer la scène du street art.'
        ]
      }
    ]
  },

  article3: {
    id: 'vinyle',
    title: 'Le vinyle fait son grand retour',
    subtitle: 'Alors que le streaming domine, les disques vinyles séduisent une nouvelle génération d\'auditeurs',
    intro: 'En 2024, les ventes de vinyles ont dépassé celles des CD pour la première fois depuis les années 1980. Ce support, que beaucoup croyaient disparu, connaît une renaissance spectaculaire portée par les jeunes mélomanes.',
    sections: [
      {
        interTitle: 'Un succès inattendu',
        paragraphs: [
          'Les chiffres parlent d\'eux-mêmes : plus de 5 millions de vinyles ont été vendus en France l\'année dernière, soit une augmentation de 30% par rapport à 2023. Ce phénomène touche tous les genres musicaux, du rock classique au hip-hop contemporain. Les magasins de disques indépendants fleurissent à nouveau dans les quartiers branchés des grandes villes.',
          'Comment expliquer cet engouement à l\'ère du numérique ? Les acheteurs évoquent la qualité sonore supérieure, le plaisir tactile de manipuler un objet physique et la dimension rituelle de l\'écoute. Poser un vinyle sur une platine devient un acte conscient, à l\'opposé de la consommation passive du streaming.'
        ]
      },
      {
        interTitle: 'Une expérience musicale totale',
        paragraphs: [
          'Le vinyle offre bien plus qu\'un simple support audio. Les pochettes grand format, véritables œuvres graphiques, font partie intégrante de l\'expérience. Collectionner des vinyles, c\'est aussi s\'approprier une histoire, celle d\'un album conçu comme un tout cohérent et non comme une simple compilation de titres.'
        ]
      },
      {
        interTitle: 'Des défis industriels',
        paragraphs: [
          'Face à cette demande croissante, l\'industrie peine à suivre. Les usines de pressage, fermées en masse dans les années 1990, sont insuffisantes. Les délais de fabrication s\'allongent, parfois jusqu\'à six mois. Certains labels investissent dans de nouvelles infrastructures, pariant sur la pérennité de ce renouveau analogique dans un monde numérique.'
        ]
      }
    ]
  }
};